import { Profiler, type PropsWithChildren } from "react";
import { trackRender } from "@-/com.npmjs.metro-bridge/client";

/**
 * Dev-only React Profiler wired to metro-mcp via `trackRender`.
 * In production builds, renders `children` with no wrapper.
 */
export function MetroBridgeProfilerRenderer({ children, id }: PropsWithChildren<{ id: string }>) {
  if (!__DEV__) {
    return children;
  }

  return (
    <Profiler id={id} onRender={trackRender}>
      {children}
    </Profiler>
  );
}
